export const validateInput = (value) => {
    const forbiddenChars = /[<>$?!&{}#*:;,=|()]/;
    return !forbiddenChars.test(value);
};

